/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 12/4/2019
 * @Example
 */

import { Image } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Loading } from "../loading/loading";

const useStyles = makeStyles({
    image: {
        '& > img': {
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            margin: '0 auto',
            zIndex: 2
        }
    },
    loading: {
        position: 'absolute',
        zIndex: 1
    },
    view: {
        zIndex: 2,
        height: '100vh !important'
    }
});

const FileViewer = (props) => {
    const classes = useStyles();
    const { filePath, fileType, height, style, className, isLoading } = props;
    const _height = typeof height === "number" ? height + 'px' : height;
    // const _height = Config.typeOf(height, 'number') ? height + 'px' : height;

    useEffect(() => {
        const { isLocal, onClose } = props;
        if (isLocal) {
            const el = document.getElementById("linkDownload");
            if (el) {
                if (onClose) onClose();
                el.click();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getViewer = (filePath, fileType) => {
        const { width, fileName, viewerProps, isLocal, isBase64, isLocalFile } = props;
        switch (fileType) {
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'bmp':
            case 'heif':
            case 'svg':
            case 'tiff':
            case 'png': {
                return <Image src={filePath} width={width || 'auto'} height={height || 'auto'}
                    {...viewerProps}
                    className={`${classes.image} ${(viewerProps?.className || '')}`}
                />;
            }
            case 'pdf':
            case 'csv': {
                let src = isLocalFile ? filePath : `https://docs.google.com/gview?url=${filePath}&embedded=true`;
                if (isBase64) src = filePath.indexOf('base64') > -1 ? filePath : `data:application/pdf;base64,${filePath}`;
                return !isLocal ? (
                    <iframe src={src} frameBorder={0}
                        title={fileName}
                        className={classes.view}
                        width={width ? width : '100%'} height={'100%'} {...viewerProps} />
                ) : (
                    <a id={"linkDownload"} href={filePath} download={fileName}>{fileName}</a>
                );
            }
            case 'doc':
            case 'docx':
            case 'xls':
            case 'xlsx': {
                return !isLocal ? (
                    <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${filePath}&activeCell=A1`} frameBorder={0}
                        title={fileName}
                        className={classes.view}
                        width={width ? width : '100%'} height={'100%'} {...viewerProps} />
                ) : (
                    <a id={"linkDownload"} href={filePath} download={fileName}>{fileName}</a>
                );
            }
            case 'mp4': {
                return (
                    <video width="auto" height="auto" controls="controls"
                        className={classes.view}
                        autoPlay={true}>
                        <source src={filePath} type="video/mp4" />
                    </video>
                )
            }
            default: {
                return <iframe title={fileName} className={classes.view} src={filePath} frameBorder={0}
                    width={width ? width : '100%'} height={'100%'} {...viewerProps} />
            }
        }
    };

    return (
        <div className={'file-viewer text-center display_row align-center valign-middle' + (className ? ' ' + className : '')}
            style={{
                height: _height,
                ...style
            }}>
            {isLoading && <Loading className={classes.loading} />}
            {filePath && fileType && getViewer(filePath, fileType)}
        </div>
    );
}

FileViewer.propTypes = {
    isBase64: PropTypes.bool,
    isLocalFile: PropTypes.bool,
    fileName: PropTypes.string,
    filePath: PropTypes.string.isRequired,
    fileType: PropTypes.string.isRequired,
    width: PropTypes.any,
    height: PropTypes.any,
    style: PropTypes.any,
    className: PropTypes.string,
    viewerProps: PropTypes.any,
};

export default FileViewer;
